import { ASSET_TYPE } from '@funnels/constants';
import { Asset, PropertyAsset, StoreApplicant } from '@funnels/types';

import { removeClientSideOwnershipReference } from '../_common';

export function cleanupPropertyAsset(asset: PropertyAsset) {
  if (asset.isConstruction === false) {
    delete asset.constructionDetails;
  }
}

export function cleanupAsset(
  asset: Asset,
  options: {
    reduxStoreApplicants: StoreApplicant[];
  }
) {
  const handledAsset = removeClientSideOwnershipReference(asset, options.reduxStoreApplicants) as Asset;
  if (handledAsset.type === ASSET_TYPE.PROPERTY) {
    cleanupPropertyAsset(handledAsset);
  }
  return handledAsset;
}
